<div class="modal-header">
  <h4 class="modal-title pull-left">
    <span *ngIf="currentFlow === getAddUserFlow()">{{'Add user' | translate}}</span>
    <span *ngIf="currentFlow === getEditUserFlow()">{{'Edit user' | translate}}</span>
    - {{'target group selection' | translate}}
  </h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="targetGroupModalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">

  <p>{{'Please select the target group of the user' | translate}}</p>

  <form [formGroup]="targetGroupForm" class="ng" fxLayout="column" novalidate>

    <div class="form-group" fxLayout fxLayout.xs="column">
      <label class="control-label" fxFlex="30">
        {{'Target group' | translate}} *
      </label>
      <div class="input-container" fxLayout="column" fxFlex>
        <ng-select
          [items]="getListOfTargetGroups()"
          bindLabel="label"
          bindValue="value"
          [clearable]="false"
          notFoundText="{{'No results found' | translate}}"
          formControlName="targetGroup">
        </ng-select>
        <div
          *ngIf="targetGroupForm.controls['targetGroup'].errors && (targetGroupForm.controls['targetGroup'].dirty || targetGroupForm.controls['targetGroup'].touched)">
          <small [hidden]="!targetGroupForm.controls['targetGroup'].errors.required" class="feedback">
            {{'Required' | translate}}.
          </small>
        </div>
      </div>
    </div>

  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-info" (click)="goToNextStep()" [ngStyle]="{'width': '100%'}"
          [disabled]="targetGroupForm.invalid">
    {{'Next' | translate}}
  </button>
</div>
